import bannerCover from '@comp/banner_cover/banner_cover'

bannerCover()
